// Häufige Fragen für die Seite /faq. Die Antworten erscheinen auch als FAQ-Strukturdaten für Google,
// deshalb nur reiner Text. Optional: link: { to, label } – Verweis unter der Antwort.
// Nur Aussagen eintragen, die für den Betrieb stimmen.
const faq = [
  {
    thema: "Allgemein",
    fragen: [
      {
        frage: "Welche Leistungen bietet Forst & Flur an?",
        antwort:
          "Baumpflege, Gefahrbaum- und Spezialbaumfällung (mit Seilklettertechnik und Arbeitsbühne), Landschaftspflege durch Mulchen, Holzeinschlag und Holzrücken sowie Hilfe bei Sturmschäden. Für Arbeiten in schwierigem Gelände setze ich die funkgesteuerte Raupe Moritz FR 75 von Pfanzelt ein.",
      },
      {
        frage: "In welchem Gebiet sind Sie im Einsatz?",
        antwort:
          "Mein Betrieb sitzt in Probsteierhagen im Kreis Plön. Von dort aus arbeite ich in ganz Schleswig-Holstein, regelmäßig in und um Kiel, Schönberg, Plön, Preetz, Lütjenburg, Lübeck, Neumünster, Eckernförde und Rendsburg. Ihr Ort ist nicht dabei? Fragen Sie einfach an.",
        link: { to: "/einsatzgebiet", label: "Zum Einsatzgebiet" },
      },
      {
        frage: "Für wen arbeiten Sie?",
        antwort:
          "Für Privatleute ebenso wie für Gutsbetriebe, Gemeinden und Unternehmen, vom einzelnen Baum im Garten bis zur Pflege von Naturschutzflächen oder eines Deponiekörpers.",
        link: { to: "/referenzen", label: "Referenzen ansehen" },
      },
      {
        frage: "Wer ist mein Ansprechpartner?",
        antwort:
          "Ich, Lasse Stoltenberg: von der ersten Besichtigung bis zum Abschluss der Arbeiten. Ich habe Agrarwirtschaft studiert und die Lehrgänge AS Baum 1 und AS Baum 2 absolviert. Je nach Aufgabe greife ich auf ein Netzwerk erfahrener Partner zurück.",
        link: { to: "/ueber-mich", label: "Mehr über mich" },
      },
    ],
  },
  {
    thema: "Ablauf und Kosten",
    fragen: [
      {
        frage: "Wie läuft ein Auftrag ab?",
        antwort:
          "Sie melden sich telefonisch oder über das Kontaktformular. Danach schaue ich mir Grundstück, Baum oder Fläche vor Ort an. Auf Grundlage dieser Besichtigung erhalten Sie ein Angebot. Sind Sie einverstanden, stimmen wir den Termin ab und ich setze die Arbeiten um.",
        link: { to: "/kontakt", label: "Jetzt anfragen" },
      },
      {
        frage: "Was kostet eine Baumfällung oder Flächenpflege?",
        antwort:
          "Das hängt stark vom Einzelfall ab: Größe und Zustand des Baumes, Platz und Zugang auf dem Grundstück, Größe und Gelände der Fläche und ob Schnittgut abgefahren werden soll. Pauschalpreise wären deshalb unseriös. Nach der Besichtigung bekommen Sie ein konkretes Angebot.",
      },
      {
        frage: "Was passiert mit dem Schnittgut?",
        antwort:
          "Ganz nach Wunsch: Astabschnitte kann ich vor Ort häckseln, das Material bleibt dann als Mulch auf dem Grundstück. Alternativ transportiere ich das Grüngut ab und entsorge es fachgerecht.",
      },
      {
        frage: "Helfen Sie auch bei Sturmschäden?",
        antwort:
          "Ja. Umgestürzte oder angebrochene Bäume, gerade in der Nähe von Gebäuden oder Straßen, sichere und beseitige ich mit Seilklettertechnik. Rufen Sie in diesem Fall am besten direkt an.",
      },
    ],
  },
  {
    thema: "Bäume und Naturschutz",
    fragen: [
      {
        frage: "Wann dürfen Bäume gefällt und Hecken geschnitten werden?",
        antwort:
          "Das Bundesnaturschutzgesetz (§ 39) verbietet vom 1. März bis 30. September, Bäume außerhalb des Waldes und außerhalb gärtnerisch genutzter Grundflächen sowie Hecken und Gebüsche zu fällen oder stark zurückzuschneiden. Schonende Form- und Pflegeschnitte sind ganzjährig erlaubt. Unabhängig von der Jahreszeit dürfen besetzte Nester und Quartiere nicht gestört werden (§ 44). Deshalb prüfe ich Bäume vor dem Eingriff auf Brutstätten.",
      },
      {
        frage: "Brauche ich eine Genehmigung, um einen Baum zu fällen?",
        antwort:
          "Das hängt von Ihrer Gemeinde ab. Viele Städte und Gemeinden haben eine Baumschutzsatzung, auch ein Bebauungsplan kann Bäume schützen. In Schleswig-Holstein sind außerdem Knicks gesetzlich geschützt. Fragen Sie im Zweifel bei Ihrer Gemeinde nach, bevor gefällt wird. Bei der Besichtigung spreche ich das mit Ihnen an.",
      },
      {
        frage: "Muss ein Baum gleich gefällt werden, wenn er Totholz hat?",
        antwort:
          "Nicht unbedingt. Ich bewerte Totäste nach Lage, Gefährdung und ökologischem Wert. Was die Verkehrssicherheit gefährdet, wird entfernt. Wo es die Sicherheit zulässt, kann Totholz bleiben, denn es ist Lebensraum für viele Käfer, Pilze und Höhlenbrüter.",
        link: { to: "/baumpflege", label: "Mehr zur Baumpflege" },
      },
    ],
  },
  {
    thema: "Landschaftspflege und Technik",
    fragen: [
      {
        frage: "Wann ist die beste Zeit für Landschaftspflege?",
        antwort:
          "In sensiblen Bereichen arbeite ich außerhalb der Brut- und Aufzuchtzeiten, bevorzugt im Herbst und Winter. Abschnittsweise Pflege lässt Rückzugsräume für Reptilien, Insekten und Wiesenvögel.",
        link: { to: "/mulchen", label: "Mehr zur Landschaftspflege" },
      },
      {
        frage: "Was ist das Besondere an der funkgesteuerten Raupe?",
        antwort:
          "Der Moritz FR 75 ist kompakt, wendig und hat einen sehr geringen Bodendruck. Damit erreiche ich steile Böschungen, feuchte Flächen und enge Bereiche zwischen Bäumen, ohne den Boden zu verdichten. Gesteuert wird er per Funk von einem sicheren Standort aus. Mit Mulcher oder Seilwinde ist er für Landschaftspflege wie für Holzrücken im Einsatz.",
        link: { to: "/baumfaellung", label: "Mehr zur Baumfällung" },
      },
    ],
  },
];

export default faq;
